module.exports = __webpack_public_path__ + "img/logo.1a2a6966.svg";